{
  "viewTransaction": "View recorded transaction",
  "cashAmounts": "Cash amounts by currency",
  "addCurrency": "Add currency amount",
  "removeCurrency": "Remove currency",
  "appName": "Currency System",
  "brand": "Al-Musafer",
  "dashboard": "Cash overview",
  "exchange": "New exchange",
  "transactions": "Transactions",
  "cash": "Funds and treasuries",
  "rates": "Exchange prices",
  "reports": "Reports",
  "configuration": "Configuration",
  "access": "Users and permissions",
  "audit": "Audit history",
  "integration": "Customer movement synchronization",
  "save": "Save",
  "working": "Working…",
  "saved": "The operation was recorded successfully.",
  "optional": "(optional)",
  "select": "Select…",
  "invalidField": "Check {{field}}.",
  "checkFields": "Check the entered fields before continuing.",
  "uncertain": "The response is unresolved. Keep this reference and resolve the original request before retrying. Do not repeat the physical cash movement.",
  "recover": "Resolve original request",
  "empty": "No records match this view.",
  "emptyInitial": "No records yet.",
  "resetFilters": "Clear filters",
  "activeFilters": "Active filters",
  "clearFilter": "Clear {{label}} filter",
  "branch": "Branch",
  "chooseBranch": "Choose your branch",
  "branchRequired": "Choose an authorized branch to begin working. Your fund and permissions follow this context.",
  "account": "Cash account",
  "kind": "Type",
  "available": "Available cash",
  "incomingTransit": "Incoming in transit",
  "outgoingTransit": "Outgoing in transit",
  "session": "Working day",
  "custodyDescription": "Available balances remain separate from cash in transit. An issued transfer becomes available only after its recipient confirms physical receipt.",
  "noCommission": "Separate service commission: 0. No additional exchange fee.",
  "refresh": "Refresh",
  "reason": "Reason",
  "physicalConfirmed": "I confirm that I physically received the customer’s cash and paid the corresponding amount.",
  "physicalHint": "Confirm only after physically checking the exact currencies and amounts. Entering a reason alone does not verify cash.",
  "pricingPath": "Pricing",
  "receivedCurrency": "Currency received from customer",
  "receivedAmount": "Cash received",
  "paidCurrency": "Currency paid to customer",
  "paidAmount": "Cash paid",
  "phone": "International phone",
  "phoneHint": "A phone number with country code is required. Other customer details are optional.",
  "fullName": "Full name",
  "email": "Email",
  "address": "Address",
  "documentType": "Document type",
  "documentNumber": "Document number",
  "documentCountry": "Issuing country code",
  "documentHint": "If a document is supplied, enter its type, number and two-letter issuing country, for example JO.",
  "replacement": "Create linked replacement",
  "replacementChain": "Replacement for {{reference}}. Its reversal stays recorded even if the new exchange fails.",
  "newExchange": "New exchange",
  "draftDescription": "Enter the exchange details to review the payout before receiving and handing over cash.",
  "offline": "Connection is unavailable. This draft is not a confirmed transaction or receipt. Posting requires an online Currency and Customer service.",
  "lookupPhone": "Phone for central lookup",
  "lookup": "Find customer",
  "customerFound": "Central customer found: {{name}}.",
  "customerNew": "No matching profile was found. A customer profile will be created when you confirm and record the exchange.",
  "calculate": "Review exchange",
  "quoteReview": "Review exchange before recording",
  "quoteReviewHint": "Check both currencies and amounts. A new rate version or expired quote requires calculation again.",
  "postExchange": "Confirm and record exchange",
  "posted": "Exchange posted",
  "postedDescription": "The exchange and its cash movements are recorded. Printing or delayed customer publication does not create another exchange.",
  "priceVersion": "Price version",
  "receivedBuy": "Applied receiving buy rate",
  "paidSell": "Applied payout sell rate",
  "expiresAt": "Quote expires",
  "roundingDifference": "Rounding difference",
  "reference": "Reference",
  "status": "Status",
  "createdAt": "Recorded at",
  "originalId": "Original transaction",
  "reversalId": "Linked reversal",
  "replacementOfId": "Replaces transaction",
  "receipt": {
    "date": "Date",
    "time": "Time",
    "received": "Amount received",
    "paid": "Amount paid",
    "rate": "Exchange rate",
    "customerName": "Customer name",
    "customerPhone": "Customer phone",
    "reference": "Reference",
    "thanks": "Thank you for visiting us"
  },
  "receiptCopy": "Receipt copy",
  "printingHint": "Print after successful posting. Closing or failing the print dialog does not cancel the exchange.",
  "print": "Print receipt",
  "reprint": "Record and print a copy",
  "printFailed": "Printing failed. The transaction remains posted; you can print again.",
  "reprintReason": "Requested an additional receipt copy",
  "transaction": "Transaction details",
  "reverse": "Reverse the whole transaction",
  "alreadyReversed": "This exchange is already reversed.",
  "cannotReverseReversal": "A reversal record cannot itself be reversed.",
  "reversalPosted": "Reversal recorded",
  "denied": "This service is outside your permissions.",
  "notFound": "The requested screen was not found.",
  "search": "Transaction reference or central customer ID",
  "currency": "Currency",
  "from": "From date",
  "to": "To date",
  "filters": "Search and filters",
  "applyFilters": "Apply filters",
  "page": "Page {{page}} of {{total}} · {{records}} records",
  "previous": "Previous",
  "next": "Next",
  "issue": "Issue cash",
  "receive": "Confirm cash receipt",
  "dispute": "Record receipt dispute",
  "cancelTransfer": "Cancel unissued transfer",
  "transferNotDraft": "This transfer is no longer a draft.",
  "transferNotAwaitingReceipt": "This transfer is not awaiting receipt.",
  "transferSelfReceiveForbidden": "You issued this transfer; a different employee must confirm receipt.",
  "funding": "Record treasury funding",
  "externalReference": "External receipt reference",
  "amount": "Amount",
  "newTransfer": "New internal cash transfer",
  "fromAccount": "Source account",
  "toAccount": "Destination account",
  "transfers": "Cash transfers",
  "transfer": "Cash transfer details",
  "newCount": "Enter a physical cash count",
  "counts": "Physical counts",
  "differences": "Shortage / overage",
  "count": "Count details",
  "actual": "Actual counted cash",
  "snapshot": "Recorded cash at count revision",
  "approveCount": "Approve explicit adjustment",
  "rejectCount": "Reject count",
  "countNotAwaitingApproval": "This count is not awaiting approval.",
  "countSelfApproveForbidden": "You submitted this count; a different manager must approve it.",
  "openSession": "Open working day with carried cash",
  "businessDate": "Business date",
  "sessions": "Working days",
  "openingBalances": "Carried opening balances",
  "closeSession": "Close working day",
  "sessionAlreadyClosed": "This working day is already closed.",
  "confirmedCount": "Current confirmed count",
  "nameAr": "Arabic name",
  "nameEn": "English name",
  "ratesHint": "Prices are JOD per currency unit. The business buys from the customer and sells to the customer. One price version applies; VIP prices require permission.",
  "ordinaryBuy": "Ordinary buy",
  "ordinarySell": "Ordinary sell",
  "vipBuy": "VIP buy",
  "vipSell": "VIP sell",
  "publishPrices": "Publish prices",
  "priceHistory": "Price history",
  "branches": "Branches",
  "currencies": "Currencies",
  "accounts": "Funds and treasuries",
  "name": "Name",
  "actions": "Actions",
  "manageStatus": "Manage availability",
  "newBranch": "Create branch",
  "code": "Code",
  "customerBranchRef": "Registered Customer branch reference",
  "newCurrency": "Create currency",
  "currencyCode": "Three-letter currency code",
  "cashScale": "Cash decimal places",
  "newAccount": "Create cash account",
  "parentAccount": "Parent treasury",
  "cashier": "Cashier",
  "reassignAccount": "Reassign closed empty cashier fund",
  "reassign": "Reassign",
  "permissions": "Service permissions",
  "description": "Description",
  "previewPermissions": "Preview current permissions and dependencies",
  "effectivePermissions": "Effective permissions",
  "affectedUsers": "Affected users: {{count}}",
  "editGroup": "Edit group",
  "newGroup": "Create group",
  "deleteGroup": "Remove group",
  "systemGroupProtected": "The built-in administrator group cannot be removed.",
  "users": "Users",
  "language": "Language",
  "arabic": "Arabic",
  "english": "English",
  "newUser": "Create user",
  "initialPassword": "Initial password",
  "editUser": "Edit user",
  "deleteUser": "Deactivate user",
  "groups": "Permission groups",
  "members": "Members",
  "newMembership": "Assign scoped group membership",
  "user": "User",
  "group": "Group",
  "scope": "Scope",
  "scopeHint": "Organization scope requires no branch selection. Branch and own-fund scopes require explicit authorized branches.",
  "memberships": "Group memberships",
  "removeMembership": "Remove membership",
  "serviceCatalog": "Service catalog and dependencies",
  "permission": "Service",
  "dependencies": "Required services",
  "organizationOnly": "Organization only",
  "scoped": "Within assigned scope",
  "reportsHint": "Totals describe recorded cash flows separately per currency. They do not represent accounting profit.",
  "exchangeCount": "Exchange records: {{count}}",
  "reversalCount": "Reversal records: {{count}}",
  "netCash": "Net cash movement",
  "exportType": "Export {{type}} to Excel",
  "ledger": "Cash ledger",
  "balances": "Balances",
  "operation": "Operation",
  "beforeAmount": "Balance before",
  "afterAmount": "Balance after",
  "resource": "Record type",
  "actor": "Acting employee",
  "requestId": "Request reference",
  "revision": "Revision",
  "attempts": "Delivery attempts",
  "lastError": "Last delivery result",
  "publicationFailed": "Customer publication needs retry or review.",
  "retryPublication": "Retry publication",
  "publicationDelivered": "This movement was already delivered to the Customer System.",
  "values": {
    "prices_published": "Price version published",
    "quote_created": "Exchange quote calculated",
    "exchange_posted": "Exchange posted",
    "exchange_reversed": "Exchange reversed",
    "branch_created": "Branch created",
    "currency_created": "Currency created",
    "account_created": "Cash account created",
    "account_reassigned": "Cashier fund reassigned",
    "receipt_reprinted": "Receipt copy requested",
    "report_exported": "Report exported",
    "outbox_retried": "Customer publication retried",
    "cash_funded": "External cash received",
    "transfer_created": "Transfer drafted",
    "transfer_issued": "Cash issued into transit",
    "transfer_received": "Cash physically received",
    "transfer_cancelled": "Draft transfer cancelled",
    "transfer_disputed": "Receipt disputed",
    "count_submitted": "Physical count entered",
    "count_rejected": "Physical count rejected",
    "count_approved": "Count adjustment approved",
    "session_opened": "Working day opened",
    "session_closed": "Working day closed",
    "EXCHANGE_POST": "Exchange posted",
    "EXCHANGE_REVERSE": "Exchange reversed",
    "EXTERNAL_RECEIPT": "External cash received",
    "User": "User",
    "Group": "Permission group",
    "Membership": "Scoped membership",
    "Branch": "Branch",
    "Currency": "Currency",
    "CashAccount": "Cash account",
    "PriceSet": "Price version",
    "Quote": "Exchange quote",
    "Exchange": "Exchange",
    "CashTransfer": "Cash transfer",
    "PhysicalCount": "Physical count",
    "FundSession": "Working day",
    "ExternalReceipt": "External receipt",
    "MovementOutbox": "Customer publication",
    "Report": "Report",
    "ACTIVE": "Active",
    "DISABLED": "Disabled",
    "SUSPENDED": "Suspended",
    "CENTRAL": "Central treasury",
    "BRANCH": "Branch",
    "CASHIER": "Cashier fund",
    "OPEN": "Open",
    "CLOSED": "Closed",
    "ORDINARY": "Ordinary",
    "VIP": "Predefined VIP",
    "NATIONAL_ID": "National identity",
    "PASSPORT": "Passport",
    "EXCHANGE": "Exchange",
    "REVERSAL": "Reversal",
    "POSTED": "Posted",
    "REVERSED": "Reversed",
    "DRAFT": "Draft",
    "ISSUED": "In transit",
    "RECEIVED": "Received",
    "DISPUTED": "Disputed in transit",
    "CANCELLED": "Cancelled",
    "SUBMITTED": "Awaiting approval",
    "CONFIRMED": "Confirmed",
    "REJECTED": "Rejected",
    "OWN_FUND": "Own cashier fund",
    "ORGANIZATION": "Organization",
    "PENDING": "Pending synchronization",
    "PROCESSING": "Sending movement",
    "DELIVERED": "Sent to Customer System",
    "FAILED": "Synchronization failed",
    "FUNDING": "External funding",
    "TRANSFER_ISSUE": "Transfer issue",
    "TRANSFER_RECEIVE": "Transfer receipt",
    "COUNT_ADJUSTMENT": "Count adjustment",
    "WEB": "Web",
    "MOBILE": "Mobile",
    "BRANCH_TREASURY": "Branch treasury",
    "auth_login": "Signed in",
    "auth_refresh": "Session refreshed",
    "auth_logout": "Signed out",
    "auth_logout_all": "All sessions ended",
    "auth_change_password": "Password changed",
    "auth_context_selected": "Branch selected",
    "user_created": "User created",
    "user_updated": "User updated",
    "user_deleted": "User deactivated",
    "group_created": "Permission group created",
    "group_updated": "Permission group updated",
    "group_deleted": "Permission group removed",
    "membership_created": "Membership assigned",
    "membership_deleted": "Membership removed",
    "entity_status_changed": "Record status changed",
    "Session": "Sign-in session"
  },
  "permissionLabels": {
    "USER_READ": "View users",
    "USER_MANAGE": "Manage users",
    "GROUP_READ": "View groups",
    "GROUP_MANAGE": "Manage groups",
    "MEMBERSHIP_MANAGE": "Manage scoped memberships",
    "CONFIG_READ": "View configuration",
    "CONFIG_MANAGE": "Manage configuration",
    "RATE_READ": "View prices",
    "RATE_MANAGE": "Publish prices",
    "CUSTOMER_RESOLVE": "Find central customer",
    "QUOTE_CREATE": "Calculate exchange",
    "EXCHANGE_POST": "Post exchange",
    "VIP_USE": "Use predefined VIP prices",
    "EXCHANGE_READ": "View exchanges",
    "EXCHANGE_REVERSE": "Reverse exchange",
    "RECEIPT_READ": "View and reprint receipts",
    "CASH_READ": "View cash custody",
    "FUNDING_POST": "Record external funding",
    "TRANSFER_CREATE": "Prepare transfers",
    "TRANSFER_ISSUE": "Issue transfers",
    "TRANSFER_RECEIVE": "Receive transfers",
    "TRANSFER_REVIEW": "Review disputed transfers",
    "COUNT_ENTER": "Enter physical counts",
    "COUNT_APPROVE": "Approve count adjustments",
    "SESSION_OPEN": "Open working day",
    "SESSION_CLOSE": "Close working day",
    "REPORT_READ": "View reports",
    "REPORT_EXPORT": "Export reports",
    "AUDIT_READ": "View audit history",
    "INTEGRATION_READ": "View Customer publication",
    "INTEGRATION_RETRY": "Retry Customer publication"
  },
  "pendingOperations": "Unresolved requests",
  "recoveredReference": "Original result recovered: {{reference}}",
  "changePassword": "Change password",
  "passwordChangeHint": "Changing your password ends all active sessions. Sign in again with the new password.",
  "currentPassword": "Current password",
  "newPassword": "New password",
  "confirmPassword": "Confirm new password",
  "activeSessions": "Active sessions",
  "logoutAll": "Sign out all sessions",
  "logoutAllHint": "End all active sessions for your account on every device.",
  "customerId": "Canonical customer identifier",
  "channel": "Execution channel",
  "verifiedAt": "Customer verified at",
  "cancelEntry": "Close form",
  "cashierFund": "Cashier fund",
  "exchangeContext": "Fund and pricing",
  "customerGives": "Receive from customer",
  "customerReceives": "Pay to customer",
  "customer": "Customer",
  "optionalCustomerDetails": "Add optional customer details",
  "phoneInvalid": "Enter a valid phone number with country code, for example +962790000000.",
  "documentInvalid": "Complete the document type, number and two-letter issuing country, or leave all document fields blank.",
  "emailInvalid": "Enter a valid email address.",
  "decimalInvalid": "Enter a valid value using digits 0–9 and a decimal point.",
  "physicalRequired": "Confirm the physical cash movement before recording this operation.",
  "calculationDetails": "Calculation details",
  "recordDetails": "Additional details and record references",
  "unnamedCustomer": "Customer name not recorded",
  "unavailableName": "Name unavailable within your access",
  "physicalReversal": "I confirm that I physically recovered the amount paid to the customer and returned the amount originally received.",
  "physicalIssue": "I confirm that I physically handed over the specified amounts for transfer.",
  "physicalReceive": "I confirm that I physically received the specified cash and checked its currencies and amounts.",
  "physicalIssueHint": "Cash stays in transit until a different employee confirms receipt at the destination.",
  "physicalReceiveHint": "Check the physical cash before confirming; it will be added to the available balance.",
  "createTransferDraft": "Create transfer draft",
  "submitCount": "Record cash count",
  "chooseAccountHint": "Select a fund or treasury to view its balances and available actions.",
  "transferFlowHint": "Create a transfer draft, then confirm handing over the cash. A different employee confirms physical receipt at the destination.",
  "countFlowHint": "Enter the cash physically counted in each currency. Difference = counted cash − recorded balance; negative is a shortage, positive is an overage.",
  "sessionFlowHint": "A working day opens with the previous day’s carried balance. Closing requires a current confirmed count; the cash remains in the cashier’s custody.",
  "dashboardHint": "Start an exchange or review branch funds and working-day status.",
  "selectedBranchBalances": "Balances you can view in the selected branch. Each currency is shown separately.",
  "allPermittedBranches": "All permitted branches",
  "allPermittedAccounts": "All permitted funds and treasuries",
  "allDates": "All dates",
  "directorySearch": "Search by name",
  "generatedAt": "Report generated",
  "updatePrices": "Update exchange prices",
  "baseCurrencyHint": "JOD is the reference currency with a fixed rate of 1. Enter each currency’s rate in JOD.",
  "permissionCount": "{{count}} permissions",
  "searchPermissions": "Find a permission",
  "profile": "Account and security",
  "reversalHint": "This reverses the full exchange using its original currencies and amounts, without current prices. The original and reversal remain recorded.",
  "countOption": "Count {{date}} — balance revision {{revision}}",
  "unknownStatus": "Unknown status",
  "requiredField": "Complete {{field}} to continue.",
  "offlineCash": "Connection is unavailable. Keep the draft; cash movement cannot be confirmed until the connection returns.",
  "employeeReference": "Employee reference",
  "shared": {
    "branchSwitchHint": "Unfinished work stays with its original branch. Switch only after reviewing pending operations; saved quotes must be reviewed again.",
    "confirmSwitch": "Switch branch",
    "account": "Shared account",
    "accountHint": "Your username, name, language and password are managed in Unified Access. Currency permissions and local status stay here.",
    "manageAccount": "Open Unified Access",
    "enroll": "Enroll a shared employee",
    "enrollHint": "Find or create the shared identity, then assign a local group and branch. Cashier assignment remains separate.",
    "provisionRecovery": "If enrollment is interrupted, search for the same username and continue linking. Creating the identity does not grant Currency access.",
    "findEmployee": "Find employee",
    "createEmployee": "Create shared identity",
    "linkIdentity": "Link shared identity",
    "username": "Username",
    "notFound": "No employee matches this username.",
    "retainHistory": "This will link the shared identity to {{name}} and preserve the existing financial history and local assignments. Local password sign-in will end.",
    "confirmEnrollment": "Confirm enrollment",
    "branchMappings": "Shared branch directory",
    "branchMappingsHint": "Link each Currency branch to its matching shared branch. Existing financial records and customer branch references are retained.",
    "mappingStatus": "Link status",
    "mapped": "Linked",
    "unmapped": "Not linked",
    "mapBranch": "Link branch",
    "centralBranch": "Shared branch",
    "previousPage": "Previous branches",
    "nextPage": "More branches",
    "accessPending": "The shared identity was created. Currency enrollment is still pending; review the employee below and complete the link.",
    "membershipRequired": "The employee is enrolled. Assign the local group and branch in Memberships before granting work access."
  },
  "screenPending": "This screen will be built in a later rebuild step.",
  "treasury": "Treasury",
  "usersScreen": {
    "title": "Users",
    "add": "Add user",
    "columns": {
      "name": "Name",
      "username": "Username",
      "email": "Email",
      "group": "Group",
      "branches": "Branches",
      "cashier": "Cashier",
      "status": "Status",
      "lastLogin": "Last login"
    },
    "cashierBadge": "Cashier",
    "active": "Active",
    "inactive": "Inactive",
    "neverLoggedIn": "Never logged in",
    "edit": "Edit",
    "delete": "Delete",
    "changeStatus": "Change status",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "requiredFieldsNote": "Required fields are marked with *.",
    "noResults": "No matching results.",
    "created": "User added successfully.",
    "updated": "User updated successfully.",
    "deleted": "User deleted successfully.",
    "statusChanged": "User status updated.",
    "passwordReset": "Password reset.",
    "statusConfirmTitle": "Confirm status change",
    "deleteConfirmTitle": "Confirm user deletion",
    "deleteConfirmDescription": "This removes {{name}}'s access to this system only. The shared Unified Access account is unaffected.",
    "resetPasswordConfirmTitle": "Confirm password reset",
    "resetPasswordConfirmDescription": "A new password will be sent for {{name}}.",
    "rowActionsTrigger": "Actions for user {{name}}",
    "drawer": {
      "createTitle": "Add user",
      "editTitle": "Edit user",
      "createDescription": "Search for an existing employee or add a new user.",
      "editDescription": "Edit the user's details and access.",
      "usernameSearch": "Search for an employee",
      "usernameSearchPlaceholder": "Unified Access username",
      "search": "Search",
      "foundEmployee": "Employee found",
      "useNewEmployee": "Use a new employee instead",
      "fields": {
        "username": "Username",
        "nameAr": "Name (Arabic)",
        "nameEn": "Name (English)",
        "email": "Email",
        "phone": "Phone",
        "group": "Group",
        "branches": "Branches"
      }
    },
    "discardTitle": "Discard changes?",
    "discardDescription": "You have unsaved changes. Discard them?",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing",
    "resetPassword": {
      "title": "Reset password",
      "emailedDescription": "A new password has been emailed to the user.",
      "linkDescription": "Use the link below to set a new password.",
      "copy": "Copy",
      "copied": "Copied",
      "close": "Close"
    },
    "setupLink": {
      "title": "Setup link",
      "emailedDescription": "A setup link has been emailed to the user.",
      "linkDescription": "Use the link below to finish the user's registration.",
      "copy": "Copy",
      "copied": "Copied",
      "close": "Close"
    },
    "search": "Name or username"
  },
  "groupsScreen": {
    "title": "Groups",
    "add": "Add group",
    "columns": {
      "name": "Name",
      "description": "Description",
      "users": "Users",
      "services": "Services",
      "status": "Status"
    },
    "active": "Active",
    "inactive": "Inactive",
    "edit": "Edit",
    "delete": "Delete",
    "changeStatus": "Change status",
    "assignServices": "Assign services",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "requiredFieldsNote": "Required fields are marked with *.",
    "noResults": "No matching results.",
    "created": "Group added successfully.",
    "updated": "Group updated successfully.",
    "deleted": "Group deleted successfully.",
    "statusChanged": "Group status updated.",
    "statusConfirmTitle": "Confirm status change",
    "deleteConfirmTitle": "Confirm group deletion",
    "deleteConfirmDescription": "This permanently deletes the {{name}} group.",
    "rowActionsTrigger": "Actions for group {{name}}",
    "drawer": {
      "createTitle": "Add group",
      "editTitle": "Edit group",
      "createDescription": "Add a new group, then assign its services from the groups list.",
      "editDescription": "Edit the group's name and description.",
      "fields": {
        "nameAr": "Name (Arabic)",
        "nameEn": "Name (English)",
        "descriptionAr": "Description (Arabic)",
        "descriptionEn": "Description (English)"
      }
    },
    "discardTitle": "Discard changes?",
    "discardDescription": "You have unsaved changes. Discard them?",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing",
    "search": "Group name"
  },
  "exchangeForm": {
    "cancel": "Cancel"
  },
  "boxesScreen": {
    "title": "Boxes",
    "tabBoxes": "Boxes",
    "tabMovements": "Box movements",
    "branch": "Branch",
    "cashierName": "Cashier",
    "boxBalance": "Box balance",
    "status": "Status",
    "viewBalance": "View balance",
    "balanceDialogTitle": "Box balance",
    "number": "Movement number",
    "date": "Date",
    "customerName": "Customer name",
    "customerPhone": "Customer phone",
    "receivedCurrency": "Received currency",
    "receivedAmount": "Amount received",
    "paidCurrency": "Paid currency",
    "paidAmount": "Amount paid",
    "profit": "Profit",
    "reversalNote": "Reversal of {{reference}}: {{reason}}",
    "notes": "Notes",
    "statusPosted": "Posted",
    "statusReversed": "Reversed",
    "syncPending": "Awaiting sync",
    "fromDate": "From date",
    "toDate": "To date",
    "filterBranch": "Branch",
    "filterCashier": "Cashier",
    "filterCurrencyIn": "Received currency",
    "filterCurrencyOut": "Paid currency",
    "filterStatus": "Status",
    "allBranches": "All branches",
    "allCashiers": "All cashiers",
    "allCurrencies": "All currencies",
    "allStatuses": "All statuses",
    "export": "Export to Excel",
    "view": "View",
    "reprint": "Reprint",
    "reverse": "Reverse",
    "reverseTitle": "Reverse the exchange",
    "reverseReason": "Reversal reason",
    "reverseWarning": "The box will return the received currency to the customer and take back the paid currency. This cannot be undone.",
    "reverseOriginal": "The box received {{received}} and paid {{paid}}. This will be reversed in full.",
    "reverseConfirm": "Confirm reversal",
    "reversePosted": "The reversal was recorded.",
    "alreadyReversed": "This exchange has already been reversed.",
    "detailsTitle": "Movement details",
    "close": "Close",
    "activeBox": "Active",
    "inactiveBox": "Inactive",
    "search": "Name or phone",
    "photo": "Customer photo",
    "photoFailed": "The photo could not be loaded.",
    "signature": "Customer signature",
    "signatureFailed": "The signature could not be loaded.",
    "customerNotPresent": "Customer not present",
    "signedAt": "Date and time",
    "signedName": "Customer name",
    "reversedBy": "Reversed by",
    "reversedAt": "Reversed at",
    "boxName": "Box name",
    "employees": "Employees",
    "box": "Box",
    "edit": "Edit",
    "addBox": "Add box",
    "filterBox": "Box",
    "allBoxes": "All boxes",
    "drawer": {
      "createTitle": "Add box",
      "editTitle": "Edit box",
      "createDescription": "Enter the box name and choose its branch and the employees who work on it.",
      "editDescription": "Change the box name and employees. The box balance does not change.",
      "name": "Box name",
      "chooseBranch": "Choose the branch",
      "branchFixed": "A box's branch cannot be changed after it is added.",
      "employees": "Employees",
      "chooseEmployees": "Choose the employees",
      "chooseBranchFirst": "Choose the branch first",
      "chooseEmployee": "Choose at least one employee",
      "employeesHint": "Only active users of the box's branch are listed.",
      "noEligibleEmployees": "No employees are available in this branch.",
      "employeesFailed": "Could not load the employees.",
      "nameTaken": "The box name is used in this branch",
      "created": "The box was added.",
      "updated": "The box was updated."
    },
    "changeStatus": "Change status",
    "statusConfirmTitle": "Confirm status change",
    "statusConfirmDeactivate": "{{name}} will be deactivated. It will not appear in the exchange app and cannot be fed; its employees stay linked.",
    "statusConfirmActivate": "{{name}} will be activated. Its employees will see it in the exchange app.",
    "statusChanged": "Box status updated.",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "saving": "Saving...",
    "customersRefused": "Customers refused this number; edit the phone"
  },
  "currenciesScreen": {
    "title": "Currencies",
    "add": "Add currency",
    "columns": {
      "name": "Currency name",
      "code": "Code",
      "buy": "Buy price",
      "sell": "Sell price",
      "vipBuy": "VIP buy price",
      "vipSell": "VIP sell price",
      "status": "Status",
      "updatedAt": "Last modified"
    },
    "active": "Active",
    "inactive": "Inactive",
    "locked": "Reference currency",
    "edit": "Edit",
    "changeStatus": "Change status",
    "createTitle": "Add currency",
    "editTitle": "Edit currency",
    "createDescription": "Add a new currency and its prices.",
    "editDescription": "Edit the currency's details and prices.",
    "fields": {
      "nameAr": "Arabic name",
      "nameEn": "English name",
      "code": "Currency code",
      "codeHint": "A three-letter international code, e.g. USD.",
      "buy": "Buy price",
      "sell": "Sell price",
      "vipEnabled": "Enable VIP price",
      "vipBuy": "VIP buy price",
      "vipSell": "VIP sell price"
    },
    "sellAtLeastBuy": "The sell price must be greater than or equal to the buy price.",
    "vipSellAtLeastBuy": "The VIP sell price must be greater than or equal to the VIP buy price.",
    "codeInvalid": "Enter a three-letter code, e.g. USD.",
    "created": "The currency was added successfully.",
    "updated": "The currency was updated successfully.",
    "statusChanged": "The currency's status was updated.",
    "statusConfirmTitle": "Confirm status change",
    "statusConfirmActivate": "{{name}} will be activated. It can be used in exchanges once active.",
    "statusConfirmDeactivate": "{{name}} will be deactivated. It will not be available for new exchanges.",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "noActions": "Reference currency, no actions",
    "rowActionsTrigger": "Actions for {{code}}",
    "discardTitle": "Discard changes?",
    "discardDescription": "You have unsaved changes. Discard them?",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing",
    "search": "Code or name",
    "noResults": "No currencies match your search."
  },
  "treasuryScreen": {
    "title": "Treasury",
    "centralFeedButton": "Feed central treasury",
    "feedButton": "Feed a box",
    "returnButton": "Return cash",
    "countButton": "Count a box",
    "tabVaults": "Vaults",
    "tabFeeds": "Box feeds",
    "tabCounts": "Box counts",
    "central": "Central treasury",
    "branchTreasury": "{{branch}} treasury",
    "viewBalance": "View balance",
    "vaultsColumns": {
      "name": "Holder",
      "balance": "Balance"
    },
    "feedsColumns": {
      "number": "Number",
      "date": "Date",
      "type": "Movement type",
      "from": "From",
      "to": "To",
      "amounts": "Amounts",
      "actor": "Performed by",
      "notes": "Notes"
    },
    "moveTypeOpening": "Opening balance",
    "moveTypeFeed": "Feed",
    "moveTypeReturn": "Return",
    "countsColumns": {
      "number": "Number",
      "date": "Date",
      "account": "Box or treasury",
      "actor": "Counted by",
      "difference": "Difference",
      "notes": "Notes"
    },
    "surplus": "Surplus",
    "shortage": "Shortage",
    "balanced": "Balanced",
    "centralFeedTitle": "Feed the central treasury",
    "centralFeedDescription": "Add cash received from outside the system into the central treasury.",
    "moveType": "Movement type",
    "moveTypeOpeningOption": "Opening balance",
    "moveTypeFeedOption": "Feed",
    "feedTitle": "Feed a box",
    "feedDescription": "Move cash from the central treasury to a branch treasury, or from a branch treasury to a cashier's box.",
    "returnTitle": "Return cash",
    "returnDescription": "Return cash from a cashier's box to its branch treasury, or from a branch treasury to the central treasury.",
    "from": "From",
    "to": "To",
    "chooseFrom": "Choose the sending party",
    "chooseTo": "Choose the receiving party",
    "amountsTitle": "Amounts",
    "availableBalance": "Available: {{amount}}",
    "notes": "Notes",
    "notesOptional": "Notes (optional)",
    "confirmTitle": "Confirm the movement",
    "confirmBody": "{{amounts}} will move from {{from}} to {{to}}.",
    "centralFeedConfirmBody": "{{amounts}} will be added to the central treasury.",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "centralFeedPosted": "The central treasury feed was recorded.",
    "feedPosted": "The feed was recorded.",
    "returnPosted": "The return was recorded.",
    "amountExceedsBalance": "The amount is greater than the available balance.",
    "atLeastOneLine": "Enter an amount for at least one currency.",
    "amountTooManyDecimals": "At most five decimal places are allowed.",
    "countTitle": "Count a box",
    "countDescription": "Choose the box or treasury, then enter the actual cash for each currency.",
    "countHolder": "Box or treasury",
    "chooseHolder": "Choose the box or treasury",
    "systemBalance": "System balance",
    "actualCash": "Actual cash",
    "difference": "Difference",
    "notesRequiredOnDifference": "Enter notes when the count has a difference.",
    "confirmCount": "Confirm the count",
    "countPosted": "The count was recorded.",
    "noHolderBalances": "This holder has no balances.",
    "discardTitle": "Discard changes?",
    "discardDescription": "You have unsaved changes. Discard them?",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing"
  },
  "servicesScreen": {
    "title": "Assign services",
    "description": "Choose the services available to this group.",
    "save": "Save permissions",
    "saving": "Saving...",
    "saved": "Permissions saved successfully.",
    "search": "Search for a service",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "unsavedChanges": "There are unsaved changes.",
    "discardTitle": "Discard changes?",
    "discardDescription": "You have unsaved permission changes. Discard them?",
    "discard": "Discard",
    "keepEditing": "Keep editing"
  },
  "reportsScreen": {
    "title": "Reports and statistics",
    "fromDate": "From date",
    "toDate": "To date",
    "filterBranch": "Branch",
    "allBranches": "All branches",
    "exportToExcel": "Export to Excel",
    "profitOverview": {
      "title": "Profit overview",
      "week": "Weekly",
      "month": "Monthly",
      "year": "Yearly"
    },
    "currencyBalances": {
      "title": "Currency balances"
    },
    "boxPerformance": {
      "title": "Box performance",
      "box": "Box",
      "cashier": "Cashier",
      "count": "Transactions",
      "profit": "Profit (JOD)"
    },
    "cashierPerformance": {
      "title": "Cashier performance",
      "cashier": "Cashier",
      "count": "Transactions",
      "profit": "Profit (JOD)"
    },
    "currencyPerformance": {
      "title": "Currency performance",
      "code": "Currency",
      "count": "Transactions",
      "received": "Received",
      "paid": "Paid"
    },
    "cashMoves": {
      "title": "Box feeds",
      "number": "Number",
      "date": "Date",
      "type": "Type",
      "from": "From",
      "to": "To",
      "amounts": "Amounts",
      "actor": "Performed by"
    },
    "boxBalances": {
      "title": "Box balances",
      "branch": "Branch",
      "box": "Box",
      "employees": "Employees",
      "balances": "Balances"
    },
    "vaultBalances": {
      "title": "Treasury balances",
      "kind": "Kind",
      "central": "Central treasury",
      "branch": "Branch treasury",
      "branchName": "Branch",
      "balances": "Balances"
    },
    "differences": {
      "title": "Differences",
      "count": "Count number",
      "date": "Date",
      "branch": "Branch",
      "actor": "Counted by",
      "currency": "Currency",
      "difference": "Difference",
      "kind": "Kind",
      "surplus": "Surplus",
      "shortage": "Shortage"
    }
  },
  "exchangeSettings": {
    "title": "Exchange settings",
    "phoneVerification": "Verify the phone number with a WhatsApp code",
    "phoneVerificationHelp": "A code is sent by WhatsApp when a customer is added or a phone is changed. The record is saved only after the code is entered.",
    "saved": "Exchange settings updated successfully"
  }
}
